import httpAuth from "../common/http/http-common";
import { DashboardUserDto, UserProfileFormDto } from "@/types/user.type";

class UserService {
  client = httpAuth("user");

  async getAllAsync(): Promise<DashboardUserDto[]> {
    const { data } = await this.client.get("all");

    return data;
  }

  async getFormAsync(id: number): Promise<UserProfileFormDto> {
    const { data } = await this.client.get(`${id}/form`);

    return data;
  }

  async updateAsync(form: UserProfileFormDto): Promise<void> {
    await this.client.put(".", form);
  }
}

export default new UserService();